import { Theme, useTheme } from '@mui/material';
import { makeStyles } from '@mui/styles';

export const useLogTableStyles = makeStyles<Theme>(() => {
  const theme = useTheme();
  return {
    tableContainer: {
      maxHeight: '60vh',
    },
    tableRow: {
      backgroundColor: theme.palette.grey[theme.palette.mode === 'dark' ? 800 : 200],
    },
    divider: {
      margin: '1rem',
    },
    deletedEntityCell: {
      fontSize: '0.875rem',
      fontWeight: 'fontWeightRegular',
      padding: 0,
      justifyContent: 'left',
      color: '#00008F',
      '&:hover': {
        textDecoration: 'underline',
        backgroundColor: 'transparent',
      },
    },
  };
});
